import { getHook } from 'react-bunja-devtools/hook';

import { createTabsComponent } from '@flipster/react/design-system';
import { IconButton } from '@flipster/react/design-system/icon-button';
import XMarkIcon from '@flipster/react/icon/generated/XMarkIcon';
import { css } from '@flipster/styled-system/css';
import { hstack, stack } from '@flipster/styled-system/patterns';

import { useResize } from './resize';
import { Brt } from './tabs/bunja/brt';
import { Flag } from './tabs/flag';

type TabsType = 'brt' | 'flag';
const Tabs = createTabsComponent<TabsType>();

interface Props {
  onClose: () => void;
}

export const Panel = ({ onClose }: Props) => {
  const { height, onMouseDown, onTouchStart } = useResize();
  const isBunjaDevtoolsEnabled = Boolean(getHook());

  return (
    <>
      <div style={{ height }} />
      <aside
        className={stack({
          zIndex: 9999, // toast zIndex(10000) 보다 작아야 스낵바를 볼 수 있음
          pos: 'fixed',
          right: 0,
          bottom: 0,
          left: 0,
          bgColor: 'background.default.level-1',
          borderTop: '1px solid',
          borderTopColor: 'border.accent.promotion',
        })}
        style={{ height, flex: `1 1 ${height}px` }}
      >
        <div
          onMouseDown={onMouseDown}
          onTouchStart={onTouchStart}
          className={css({
            zIndex: 2,
            pos: 'absolute',
            top: 0,
            h: 4,
            w: '100%',
            cursor: 'ns-resize',
            _hover: {
              bgColor: 'border.accent.promotion',
            },
            _active: {
              bgColor: 'border.accent.promotion',
            },
          })}
        />
        <div className={hstack({ pt: 8, px: 12, justify: 'space-between' })}>
          <p className={css({ textStyle: 'Title/XS', color: 'content.default.level-5' })}>Prex Devtools</p>
          <div className={hstack()}>
            <IconButton size='small' hierarchy='tertiary' icon={<XMarkIcon />} onClick={onClose} />
          </div>
        </div>
        <Tabs
          size='small'
          type='scrollable'
          defaultValue={isBunjaDevtoolsEnabled ? 'brt' : 'flag'}
          css={stack.raw({ flex: 1, minH: 0 })}
          panelCss={{ flex: 1, minH: 0 }}
        >
          {isBunjaDevtoolsEnabled && (
            <Tabs.Tab value='brt' label='BRT'>
              <Brt />
            </Tabs.Tab>
          )}
          <Tabs.Tab value='flag' label='Flag'>
            <Flag />
          </Tabs.Tab>
        </Tabs>
      </aside>
    </>
  );
};
